export default __webpack_public_path__ + "static/media/screenBlock22.f89b545e.jpg";